import React from 'react';
import { useTranslation } from 'react-i18next';

const FooterInfo = () => {
  const { t } = useTranslation();

  return (
    <div className={'footer-info-layout-group'}>
      <div className={'footer-info-line-group footer-info-line01-group'}>
        <span className={'footer-info company-info type-divide'}>{t('vlending_co')}</span>
        <span className={'footer-info address-info type-divide'}>
          {t('representative_label')} : {t('representative_info')}
        </span>
        <br className={'mb-show'} />
        <span className={'footer-info address-info'}>{t('address_info')}</span>
      </div>
      <div className={'footer-info-line-group footer-info-line02-group'}>
        <span className={'footer-info biz-number-info type-divide'}>{t('biz_number_label')} : 329-81-01568</span>
        <br className={'mb-show'} />
        <span className={'footer-info e-commerce-number-info type-divide'}>
          {t('e_commerce_number_label')} : {t('e_commerce_number_info')}
        </span>
        <a href={'tel:+8227848560'} className={'footer-info tel-number-info type-with-icon'}>
          <span className={'footer-info-icon-group'}>
            <i className={'icon icon-call'} />
          </span>
          +82-2-784-8560
        </a>
      </div>
    </div>
  );
};

export default FooterInfo;
